<template>
  <div class="course-support-box">
    <div class="show-flex-box-c">
      <dl class="show-flex-box-c">
        <dt class="show-flex-box-c">
          <span>课程支持</span>
          <strong></strong>
        </dt>
        <dd class="choose-answer show-flex-box-c">
          <strong>围绕创新人才早期发现与贯通培养，德阳经开区社事局构建了体系化的课程体系</strong>
        </dd>
        <dd class="choose-pic-box show-flex-box-r">
          <span>
            <img src="../../assets/home/course_support.jpg" alt="德阳经开科创" draggable="false">
          </span>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  name: 'course_support_cpn',
  data () {
    return {
      
    }
  }
}
</script>

<style lang="less" scoped>

  //公共字体样式  start
  .course-support-font-style( @size; @weight; @height; @color ) {
    display: block;
    font-size: @size;
    font-weight: @weight;
    line-height: @height;
    color: @color;
    word-break: break-all;
  }

  .course-support-box{
    width: 100%;
    height: 889px;
    &>div{
      margin: 0 auto;
      width: 1200px;
      align-items: center;
      &>dl{
        width: 100%;
        align-items: center;
        &>dt{
          align-items: center;
          &>span{
            word-wrap: none;
            .course-support-font-style( 40px; bold; auto; #191D21 );
            padding-top: 84px;
          }
          &>strong{
            display: block;
            width: 130px;
            height: 5px;
            background: #FF7800;
            margin-top: 19px;
            margin-bottom: 48px;
          }
        }
        &>.choose-answer{
          align-items: center;
          padding-bottom: 51px;
          &>strong{
            .course-support-font-style( 18px; 400; 34px; #3E3A39 );
          }
        }
        &>.choose-pic-box{
          justify-content: center;
          &>span{
            width: 1066px;
            &>img{
              width: 100%;
              height: auto;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/course_support_cpn.vue